import { z } from 'zod/v4';

import { columns } from './columns';

export const customerSchema = z.object(columns);

export type Customer = z.output<typeof customerSchema>;

// These max lengths are based on character limits in Visual's database
export const CUSTOMER_NAME_MAX_LENGTH = 50;
export const CUSTOMER_ATTENTION_NAME_MAX_LENGTH = 50;
export const CUSTOMER_ADDRESS1_MAX_LENGTH = 50;
export const CUSTOMER_ADDRESS2_MAX_LENGTH = 50;
export const CUSTOMER_CITY_MAX_LENGTH = 30;
export const CUSTOMER_STATE_MAX_LENGTH = 10;
export const CUSTOMER_POSTAL_CODE_MAX_LENGTH = 10;

export const customerHeaderSchema = customerSchema
  .pick({
    name: true,
    attentionName: true,
    email: true,
    phone: true,
    address1: true,
    address2: true,
    city: true,
    state: true,
    postalCode: true,
    countryCode: true,
    discountCode: true,
    marketCode: true,
  })
  .partial();

export type CustomerHeader = z.output<typeof customerHeaderSchema>;
